import $ from 'jquery';
import debounce from 'lodash/debounce';

export default class MultiSelect {
	constructor ($root) {
		this.$root = $root;
		this.id = this.$root.data('multiselect');
		this.$paramsContainer = $(`[data-multiselect-params="${this.id}"]`);
		this.$search = $(`[data-multiselect-search]`);
		this.classes = {
			open: 'is-open'
		};
		this.$dropdown = this.$root.find('[data-multiselect-dropdown]');
		this.watchForClose = (event) => {
			const $target = $(event.target);
			if (this.$root[0] !== $target.closest('[data-multiselect]')[0]) {
				this.close();
			}
		};
		this.watchForClose.bind(this);
		this.$inputs = this.$root.find('[data-multiselect-input]');
		this.$holder = this.$root.find('[data-holder]');
		this.activeParams = [];
		this.$reset = this.$paramsContainer.find('[data-param-reset]');
		this.$dropdown = this.$root.find('[data-multiselect-dropdown]');
	}

	get params () {
		return this.$paramsContainer.find('[data-param]');
	}

	open () {
		this.$root.addClass(this.classes.open);
		$(window).on('click', this.watchForClose);
	}

	close () {
		this.$root.removeClass(this.classes.open);
		$(window).off('click', this.watchForClose);
	}

	onInputsChange (e) {
		const $this = $(e.currentTarget);
		if ($this.prop('checked') === true) {
			const name = $this.data('name');
			const value = $this.data('value');
			this.activeParams.push({ name: name, value: value });
			this.setHolderData(value);
		} else {
			const name = $this.data('name');
			const value = $this.data('value');
			this.activeParams = this.activeParams.filter((obj) => obj.name !== name);
			const $param = this.params.filter((i, el) => $(el).data('param') === value);
			this.removeParam(value, $param);
		}
	}

	attachHandlers () {
		this.$root.on('click', () => {
			this.open();
		});
		this.$inputs.on('change', (e) => {
			this.onInputsChange(e);
		});

		this.$reset.on('click', () => {
			this.resetSelect();
		});

		this.$paramsContainer.on('click', this.params, (e) => {
			const $this = $(e.target).closest('[data-param]');
			this.removeParam($this.data('param'), $this);
		});

		this.$search.on('input', debounce((e) => {
			const $input = $(e.currentTarget);
			const url = $input.data('url');
			const query = $input.val();
			$.ajax({
				method: 'POST',
				url: url,
				data: {
					query: query
				}
			})
				.done((resp) => {
					const $markup = $(resp.html);
					$markup.find('[data-multiselect-input]').each((i, el) => {
						const $el = $(el);
						if (this.activeParams.find((obj) => obj.name === $el.data('name'))) {
							$el.prop('checked', true);
						}
					});
					this.$dropdown.html($markup);
					this.$dropdown.find('[data-multiselect-input]').on('click', (e) => {
						this.onInputsChange(e);
					});
				})
				.fail(() => {
					console.warn('Ошибка загрузки данных');
				});
		}, 300));
	}

	removeParam (param, $element) {
		const $targetInput = this.$inputs.filter((i, el) => $(el).data('value') === param);
		let holderVal = JSON.parse(this.$holder.val()).filter((val) => val !== param);
		this.activeParams = this.activeParams.filter((obj) => obj.value !== param);
		this.$holder.val(holderVal.length ? JSON.stringify(holderVal) : '');
		$targetInput.prop('checked', false);
		$element.remove();
		this.$holder.trigger('change');
	}

	resetSelect () {
		this.$inputs.prop('checked', false);
		this.clearParams();
		this.$holder.val('');
		this.activeParams = [];
		this.$holder.trigger('change');
	}

	clearParams () {
		this.params.remove();
	}

	attachParams () {
		this.clearParams();
		const params = this.activeParams.reduce((acc, obj) => {
			return this.createParam(obj.name, obj.value) + acc;
		}, '');
		this.$paramsContainer.prepend(params);
	}

	createParam (name, value) {
		return `<div class="param" data-param="${value}">
			<span>${name}</span>
			<svg class="param__icon">
				<use xlink:href="/Media/assets/images/sprites/icons.svg#close"></use>
			</svg>
		</div>`;
	}

	setHolderData (data) {
		let currentValue = this.$holder.val() ? JSON.parse(this.$holder.val()) : [];
		currentValue.push(data);
		this.$holder.val(JSON.stringify(currentValue));
		this.attachParams(currentValue);
		this.$holder.trigger('change');
	}

	removeDataFromHolder (data) {
		let currentValue = JSON.parse(this.$holder.val());
		const newVal = currentValue.filter((val) => val !== data);
		this.$holder.val(newVal.length ? JSON.stringify(newVal) : '');
	}

	init () {
		this.attachHandlers();
	}
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_classes/MultiSelect.js